import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { constitutionalControls } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpControls() {
  return <section className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-2441" data-mp="3f2u2vkr06l4g">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2442" data-mp="3k1f7rxh79sz8">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 mb-16" data-id="element-2443" data-mp="362ffmfuhavyb">
          <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl tracking-tight leading-tight" data-id="element-2444" data-mp="3a49cse5gthtq">
            Constitutional controls by design
          </h2>
          <div className="lg:col-span-7" data-id="element-2445" data-mp="3132ubzj99wxu">
            <p className="text-xl text-white/80 leading-relaxed" data-id="element-2446" data-mp="31447qanquviq">
              The Cognarchism founding charter calls for evaluative systems that
              are auditable and reviewable, with notice of adverse grounds,
              rights of appeal and correction, and pathways to restoration.
              Notice, correction, review, and reassessment are requirements of
              the connected application architecture, not of the knowledge graph
              alone.
            </p>
            <p className="mt-5 text-lg text-white leading-relaxed" data-id="element-2447" data-mp="3lit7estsm4hv">
              SKP would preserve approved policies, definitions, sources, and
              version history. Connected operational systems would enforce
              permissions, manage cases, and carry out review and appeals.
              Noetivra could provide the authorized interface for inspecting
              records and participating in those workflows.
            </p>
            <a href="https://cognarchism.org/" target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 font-semibold text-teal hover:text-white transition-colors duration-150 whitespace-nowrap" data-id="element-2448" data-mp="2xuics7eox121">
              Learn more about Cognarchism
              <ArrowUpRight size={18} aria-hidden="true" data-id="element-2449" data-mp="36v7tco5i6etl" />
              <span className="sr-only" data-id="element-2450" data-mp="3bvcb0hi5dfle">(opens cognarchism.org in a new tab)</span>
            </a>
          </div>
        </motion.div>

        <motion.dl {...fadeUp} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 border-t border-white/15" data-id="element-2451" data-mp="3fwpeikxrp6p5">
          {constitutionalControls.map(control => <div key={control.title} className="border-b border-white/15 py-8" data-id="element-2452" data-mp="2o6t5uaue9ixj">
              <dt className="font-heading font-bold text-xl mb-2" data-id="element-2453" data-mp="2s6lesonp9r3f">{control.title}</dt>
              <dd className="text-white/70 leading-relaxed" data-id="element-2454" data-mp="2x6ptqa8ymdrj">{control.body}</dd>
            </div>)}
        </motion.dl>

        <motion.div {...fadeUp} className="mt-14 border border-white/20 rounded-lg p-8 lg:p-10 max-w-4xl" data-id="element-2455" data-mp="31y7vh0it4idk">
          <p className="text-lg text-white leading-relaxed mb-4" data-id="element-2456" data-mp="24fpppzamp9zv">
            These systems can support such controls; they cannot make an
            unvalidated assessment fair simply by recording it.
          </p>
          <p className="text-white/70 leading-relaxed" data-id="element-2457" data-mp="1wy9pbs07k7lz">
            Any proposed use of NCJI for role qualification or civic access
            requires evidence that its measures are fit for that use and
            procedures that allow meaningful human challenge.
          </p>
        </motion.div>
      </div>
    </section>;
}